import { STPOwnershipType } from "./stp_ownership_type.model";

export class Ministry {
  public id: number;
  public stpOwnershipType: number;
  public ministryName: string;

  public remarks: String;

  public stpOwnershipTypeName : String;
  public page : number;
  public size : number;
  public sortingKey: String;
  public sortingValue: String;


  constructor() {}
}
